import { FC } from 'react'
import IconSwitchMobile from 'assets/switch-mobile.svg?react'
import { ButtonIcon } from 'components/extend/ButtonIcon'

import { OrderFilterSearchField } from './OrderFilterSearchField'

import s from './OrderFilterSearchField/OrderFilterSearchField.module.less'

export interface OrderFilterMobileSearchFieldsProps {
  departure: string
  destination: string
  onSetDeparture: (value: string) => void
  onSetDestination: (value: string) => void
  onSwapPoints: () => void
}

export const OrderFilterMobileSearchFields: FC<OrderFilterMobileSearchFieldsProps> = ({
  departure,
  destination,
  onSetDeparture,
  onSetDestination,
  onSwapPoints
}) => (
  <div className={s.searchsMobileBlock}>
    <div className={s.searchsMobile}>
      <OrderFilterSearchField onChange={onSetDeparture} type="departure" value={departure} />
      <OrderFilterSearchField onChange={onSetDestination} type="destination" value={destination} />
    </div>
    <ButtonIcon className={s.iconSwitch} icon={IconSwitchMobile} onClick={onSwapPoints} rotate={90} />
  </div>
)
